import { useEffect, useState } from "react";
import { FlaskConical } from "lucide-react";
import { adminApi } from "@/lib/api";

export function TestModeBanner() {
  const [testMode, setTestMode] = useState<boolean | null>(null);

  useEffect(() => {
    adminApi.publicSettings()
      .then((s) => setTestMode(s.testMode))
      .catch(() => setTestMode(false));
  }, []);

  if (testMode !== true) return null;

  return (
    <div className="rounded-xl border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900">
      <div className="flex items-start gap-3">
        <FlaskConical className="mt-0.5 size-5 shrink-0 text-amber-700" />
        <div className="space-y-1">
          <p className="font-semibold">Test Mode Active</p>
          <p className="text-amber-800">
            Minimum booking and ticket amounts have been lowered to ₦10 for testing. Small real payments will still be processed — use low amounts to verify the full flow without significant cost.
          </p>
        </div>
      </div>
    </div>
  );
}
